import { render, staticRenderFns } from "./CcloneDetails.vue?vue&type=template&id=1ee6af60&lang=pug"
import script from "./CcloneDetails.vue?vue&type=script&lang=js"
export * from "./CcloneDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports